import { defineMessages } from "react-intl";

export const saveWarningsMessages = defineMessages({
  title: {
    id: "extrasCategories.accommodationLimits.warnings.title",
    defaultMessage: "Accommodation saved",
  },
  intro: {
    id: "extrasCategories.accommodationLimits.warnings.intro",
    defaultMessage: "Saved with warnings:",
  },
  accept: {
    id: "extrasCategories.accommodationLimits.warnings.accept",
    defaultMessage: "Accept",
  },
});
